const rootActionPath = 'core/StickyCtaBar';

export const STICKY_CTA_BAR_VIEW = `${rootActionPath}/VIEW`;
